import script from "./Page1.vue?vue&type=script&setup=true&lang=js"
export * from "./Page1.vue?vue&type=script&setup=true&lang=js"

import "./Page1.vue?vue&type=style&index=0&id=8994dd90&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8994dd90"]])

export default __exports__